//NOTE: this event emitter only allows ONE listener per event tag, so if you add another
//listener with the same tag name you WILL overwrite the first one.
const eventMap = new Map<string, (...e: any) => void>();

export function on(tag: string, func: (...e: any) => void): void {
	eventMap.set(tag, func);
}

export function off(tag: string): void {
	eventMap.delete(tag);
}

export function broadcastEvent(tag: string, ...args: any[]): void {
	eventMap.get(tag)?.(...args);
}

export function removeAll(): void {
	eventMap.clear();
}

/**

************************
Usage
************************

import * as EventEmitter from './path/to/event-emitter.ts'

function myComponent() {
	const [foo, setFoo] = useState('');

	useEffect(() => {
		//declare the handler
		const myHandler = (someArg: someType) => {
			setFoo(someArg);
		}

		//listen for the event
		EventEmitter.on('some-event', myHandler);

		//remove the event listener
		return () => {
			EventEmitter.off('some-event');
		}
	}, []);
}

function myOtherComponent() {
	function emitTheEvent() {
		EventEmitter.broadcastEvent('some-event', someVariable);
	}

	return (
		<button onClick={emitTheEvent}>Emit Event</button>
	)
}

*/